import { TokenDetails } from './models/auth/token-details.type';
import { AuthenticationService } from './services/api/authentication/authentication.service';
import { TokenService } from './services/api/authentication/token.service';
import { InspectionService } from './services/api/inspection/inspection.service';
import { CubeService } from './services/cube/cube.service';
import { TemplateLoaderService } from './services/template-loader/template-loader.service';
import { UserService } from './services/user/user.service';
import { AuthActions } from './store/actions/auth.actions';
import { AppState } from './store/state/app.state';

import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

// https://medium.com/@gmurop/managing-dependencies-among-app-initializers-in-angular-652be4afce6f
// https://www.intertech.com/Blog/angular-4-tutorial-run-code-during-app-initialization/

export function authInitializer(
  authService: AuthenticationService,
  cubeService: CubeService,
  inspectionService: InspectionService,
  store: Store<AppState>,
  templateLoaderService: TemplateLoaderService,
  tokenService: TokenService,
  userService: UserService
): () => Promise<any> {
  try {
    return (): Promise<any> =>
      initB2C(
        authService,
        cubeService,
        inspectionService,
        store,
        templateLoaderService,
        tokenService,
        userService
      );
  } catch (e) {
    console.error(e);
  }
}

function initB2C(
  authService: AuthenticationService,
  cubeService: CubeService,
  inspectionService: InspectionService,
  store: Store<AppState>,
  templateLoaderService: TemplateLoaderService,
  tokenService: TokenService,
  userService: UserService
): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      const isOnline = await inspectionService.getOnlineStatus();
      cubeService.setOnlineStatus(isOnline); // Set the online status using CubeService

      if (isOnline) {
        store.dispatch(AuthActions.Login());
      } else {
        await Promise.all([
          userService.setOfflineUser(),
          userService.setOfflineActiveRole(),
          userService.setOfflineRolesAndModules(),
        ]);
      }
      setTokenDetails(authService, store, tokenService);

      // Load the runtime template config
      templateLoaderService.loadRuntimeTemplateConfig();
      return resolve(true);
    } catch (error) {
      console.error('Error during initialization:', error);
      return reject(error);
    }
  });
}

function setTokenDetails(
  authService: AuthenticationService,
  store: Store<AppState>,
  tokenService: TokenService
): void {
  authService.token
    .pipe(filter((token: string | undefined): token is string => !!token))
    .subscribe((token) => {
      const uniqueId = tokenService.getUniqueId(token);
      const tokenDetails = tokenService.decodeToken(token);
      store.dispatch(
        AuthActions.setTokenDetails({
          tokenDetails: {
            idToken: token,
            uniqueId,
            idTokenClaims: tokenDetails,
          } as TokenDetails,
        })
      );
    });
}
